@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.title {
  line-height: unset;
}

.description {
  color: var(--muted-old);
  text-wrap: balance;
}

.footer {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  padding-top: 1rem;
  margin-top: auto;
}

.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: var(--z-backdrop);
  display: grid;
  place-items: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
  overflow-y: auto;
  background-color: var(--backdrop-background);

  &[data-state="open"] {
    animation: fadeIn 100ms ease-out;
  }

  &[data-state="closed"] {
    animation: fadeOut 100ms ease-in;
  }
}

.content {
  --modal-padding: 1.5rem;
  --modal-padding-negative: calc(var(--modal-padding) * -1);
  position: relative;
  z-index: var(--z-modal);
  display: flex;
  flex-direction: column;
  width: 90vw;
  max-width: 600px;
  padding: var(--modal-padding);
  color: var(--modal-color);
  background-color: var(--modal-background);
  border-radius: 1rem;
  box-shadow:
    hsl(206 22% 7% / 35%) 0 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0 10px 20px -15px;
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

  &:focus {
    outline: none;
  }

  @keyframes contentShow {
    from {
      opacity: 0;
      transform: translateY(5%) scale(0.96);
    }

    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
}

.padding {
  padding: var(--modal-padding);
  margin-top: var(--modal-padding-negative);
  margin-right: var(--modal-padding-negative);
  margin-left: var(--modal-padding-negative);

  &:last-child {
    margin-bottom: var(--modal-padding-negative);
  }
}

.contentPadding {
  padding: var(--modal-padding);
  margin-right: var(--modal-padding-negative);
  margin-left: var(--modal-padding-negative);
}

.loadingWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  > div {
    display: flex;
    align-self: center;
  }
}

.closeIcon {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-flex;
  flex-direction: row;
  gap: 0.125rem;
  align-items: center;
  padding: var(--modal-padding);
  font-family: inherit;
  color: var(--on-background);

  [aria-busy="true"] & {
    display: none;
  }

  &:focus {
    outline: none;
  }
}
